import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { createPostPurchaseSurveyParamsModel } from "@/domains/surveys/factories/create-post-purchase-survey-params-model";
import { postPurchaseQueryOptions } from "@/domains/surveys/factories/post-purchase-query-options";

export const usePostPurchaseSurveyParams = (orderId: number) => {
  const { data, ...queryResult } = useQuery({
    ...postPurchaseQueryOptions.flowParams(orderId),
  });

  const surveyParams = useMemo(() => {
    return createPostPurchaseSurveyParamsModel(data);
  }, [data]);

  return {
    surveyParams,
    ...queryResult,
  };
};
